import axios from 'axios'
import router from '../router'
import global from '../components/Global'

// 请求成功，返回的状态码不是业务定义状态码时调用
// const statusError = (err) => {
// }

// // 网络出错时调用
// const requestError = (err) => {
//   // let errorText = ''
//   // if (err.response && err.response.status) {
//   //   errorText = '请求错误：' + err.response.status + ',' + err.response.statusText
//   // }
//   // if (/Error/.test(err)) {
//   //   errorText = '请求超时'
//   // }
// }

axios.defaults.timeout = 30 * 1000
axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.baseURL = process.env.VUE_APP_API

axios.interceptors.request.use((config) => {
    if(global.isPC()){
        config.headers.common.x_request_platform = 'WEB'
        config.headers.common.x_request_application = 'Tupperofficial'
    }else{
        config.headers.common.x_request_platform = 'MOBILE'
        config.headers.common.x_request_application = 'Tupperofficial'
    }
  return config
}, (err) => {
  return Promise.reject(err)
})

axios.interceptors.response.use((rs) => {
  const codeArr = ['1410', '1411', '1415', '1102', '1420', '1421', '1422'] // 做另外处理的resultCode
  if (rs.data.success) {
    return rs
  } else {
    if (rs.data.resultCode === '403') {
      // statusError(rs.data)
      router.push({
        path: '/login'
      })
      return
    } else if (codeArr.indexOf(rs.data.resultCode) >= 0) { // 特殊性：兼容提交订单接)
      return rs
    }
    // statusError(rs.data)
    return Promise.reject(rs.data)
  }
}, (err) => {
  console.log(err)
  // requestError(err)
})

export default function (options,useWx = false,type) {
  if (!options) {
    return
  }

  if(useWx) {
    axios.defaults.baseURL = process.env.WX_API
  }

  if(type == 'hsy') {
    axios.defaults.baseURL = process.env.HSY_API
  }

  if(type == 'hgl') {
    axios.defaults.baseURL = process.env.HGL_API
  }

  if(type == 'ali') {
    axios.defaults.baseURL = process.env.ALI_PAY
  }

  const config = {
    url: options.url,
    method: options.method
  }
  if (options.method === 'get') {
    config.params = options.data
  }
  if (options.method === 'post') {
    config.data = options.data
  }
  return new Promise((resolve, reject) => {
    axios(config).then(rs => {
      resolve(rs.data)
    }, err => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/util/axios.js